import type { FunctionComponent } from 'react';
import { Embedded } from '../../components/embedded/Embedded';
import type { EmbeddedFragment } from '../../graphql/fragments/EmbeddedFragment.graphql';
import { useGetEmbedded } from '../../graphql/hooks/embedded';
import { suspense } from '../../lib/utils/suspense';

/**
 * Renders a standalone iframe section, for youtube videos and such.
 */
export const EmbeddedInternal: FunctionComponent<EmbeddedFragment> = ({
  sys,
  type,
  ...restOfProps
}) => {
  if (restOfProps?.src) {
    return <EmbeddedInternalResolved sys={sys} type={type} {...restOfProps} />;
  }
  return <SelfFetchingEmbeddedInternal sys={sys} type={type} data-sentry-element="SelfFetchingEmbeddedInternal" data-sentry-component="EmbeddedInternal" data-sentry-source-file="embedded.tsx" />;
};
const SelfFetchingEmbeddedInternal: FunctionComponent<EmbeddedFragment> = ({
  sys,
  type
}) => {
  const {
    data
  } = useGetEmbedded({
    variables: {
      id: sys.id
    }
  });
  return <EmbeddedInternalResolved sys={sys} type={type} {...data} data-sentry-element="EmbeddedInternalResolved" data-sentry-component="SelfFetchingEmbeddedInternal" data-sentry-source-file="embedded.tsx" />;
};
const EmbeddedInternalResolved: FunctionComponent<EmbeddedFragment> = suspense(embedded => {
  const src = embedded?.src;
  if (!src) return null;
  return <Embedded {...embedded} src={src} width='100%' />;
});
export default EmbeddedInternal;